import { TestPaper } from '@/uikit/TestPaper/TestPaper'
import { QuizMode } from '@/uikit/TestPaper/types'
import {
  ReviewedStatusEnum,
  courseApi,
  paperApi,
} from 'packages/sdks-next/growp'
import React, { useContext, useEffect } from 'react'
import {
  CourseReviewedStatusToQuizMode,
  useUpdateOutlineComplete,
} from '../../utils'
import { CourseContext } from '../../context'
import { Modal, Toast } from '@seiue/ui'
import { find } from '@seiue/util'
import styled from 'styled-components'
import { GrowpIcon } from 'packages/components/GrowpIcon'
import { message } from 'antd'

export const PaperContent: React.FC<{
  taskId: number
  paperId: number
}> = ({ taskId, paperId }) => {
  const { currentOutline, isPreview, completedDetails } =
    useContext(CourseContext)
  const completedDetail = find(completedDetails, {
    outlineTaskId: currentOutline?.id,
  })
  const { data, loading } = paperApi.useQueryBlocks({
    paperId,
    query: {
      sort: 'weight',
      expand: ['questions'],
      paginated: 0,
    },
  })

  const { data: paperInfo } = paperApi.useLoadPaper(
    {
      id: paperId,
    },
    {
      disable: !paperId,
    }
  )
  const { api: updateExerciseViewed } = courseApi.useUpdateExerciseViewed()

  useEffect(() => {
    if (!isPreview && (!completedDetail || !completedDetail?.reviewedStatus)) {
      updateExerciseViewed({
        outlineTaskId: currentOutline?.id || 0,
        outlineId: currentOutline?.parentId || 0,
        id: taskId,
      })
    }
  }, [completedDetail?.reviewedStatus])

  const updateOutlineComplete = useUpdateOutlineComplete()
  const { data: result, loading: resultLoading } =
    courseApi.useQueryCourseReflectionCompleted({
      bizId: currentOutline?.id || 0,
      query: {
        isForeground: true,
      },
    })
  const { api: modifyOutlineTaskSave } = courseApi.useModifyOutlineTaskSave({
    reload: [courseApi.queryCourseReflectionCompleted],
  })
  const { answers, reviews } = result || {}
  const getMode = () => {
    if (isPreview) {
      return QuizMode.Preview
    }
    if (completedDetail?.reviewedStatus) {
      return CourseReviewedStatusToQuizMode.get(
        completedDetail.reviewedStatus as ReviewedStatusEnum
      )
    }
    return QuizMode.Answering
  }
  return (
    <div>
      {completedDetail?.reviewedStatus === ReviewedStatusEnum.Submitted ? (
        <Notification>
          <GrowpIcon
            name="WarnFill"
            fill="#FF8800"
            size={14}
          />
          <div>已提交等待批阅</div>
        </Notification>
      ) : null}
      <TestPaperWrapper
        $waitReviewed={
          completedDetail?.reviewedStatus === ReviewedStatusEnum.Submitted
        }
      >
        <TestPaper
          showScore={!!paperInfo?.showScore}
          allowSave={true}
          blocks={data || []}
          loading={loading || resultLoading}
          initValue={answers}
          reviews={reviews}
          mode={getMode()}
          onSubmit={async (answers) => {
            Modal.confirm({
              title: '确定提交习题吗？',
              content: '正在提交习题，提交后不可修改习题答案，确定提交吗？',
              onOk: async () => {
                await updateOutlineComplete({
                  taskId: currentOutline?.id || 0,
                  id: currentOutline?.parentId || 0,
                  payload: {
                    isCompleted: true,
                    answers,
                  },
                })
                Toast.success('提交成功')
              },
            })
          }}
          onSave={async (answers) => {
            await modifyOutlineTaskSave({
              taskId: currentOutline?.id || 0,
              id: currentOutline?.parentId || 0,
              payload: {
                answers,
                isCompleted: false,
              },
            })
            message.success('保存成功')
          }}
        />
      </TestPaperWrapper>
    </div>
  )
}

const Notification = styled.div`
  width: 100%;
  height: 40px;
  position: absolute;
  top: 59px;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 9px 0;
  text-align: center;
  font-size: 14px;
  color: ${(props) => props.theme.text._1};
  background-color: #fff8e8;
  & > div {
    margin-left: 8px;
  }
`

const TestPaperWrapper = styled.div<{
  $waitReviewed: boolean
}>`
  margin-top: ${(props) => (props.$waitReviewed ? '20px' : '0px')};
`
